// Advent page: tells Microsoft Clarity exactly which zone was tapped, because Clarity's own click labels are
// ambiguous (the pill "XL" and a product's "XL" button look identical, numbers are masked as "▫", etc).
// One Clarity event per tap, e.g. advent_tap_filter_pill_XL, advent_tap_card_size_XL, advent_tap_slot_empty.
// The events show up in the session timeline next to any dead click, and can be filtered/counted in Clarity.
(function() {
  var config = window.lakorAdventTracking || {};

  function clarityCall() {
    if (typeof window.clarity === 'function') window.clarity.apply(window, arguments);
  }

  // Which test variants this visitor is seeing, so sessions can be filtered by them
  clarityCall('set', 'advent_image_tap_action', config.imageTapAction || 'none');
  clarityCall('set', 'advent_empty_slot_scroll', config.emptySlotScroll ? 'on' : 'off');

  function zoneFor(target) {
    var el;

    if ((el = target.closest('.lakor-size-pill'))) return 'filter_pill_' + (el.dataset.size || 'all');
    if (target.closest('#lakor-size-filter-popover, .lakor-size-filter')) return 'filter_dropdown';

    if ((el = target.closest('.advent__product_slot'))) {
      if (target.closest('button')) return 'slot_remove';
      if (el.classList.contains('pending')) return 'slot_pending';
      if (!el.classList.contains('filled')) return target.closest('p.number') ? 'slot_empty_number' : 'slot_empty';
      return 'slot_filled_' + (target.closest('p.title') ? 'label' : 'photo');
    }

    if ((el = target.closest('.product-item'))) {
      var blocked = el.closest('.advent-limit-reached') && !el.classList.contains('selected') ? '_blocked' : '';
      var sizeButton = target.closest('.button--size-select');
      if (sizeButton) return 'card_size_' + sizeButton.textContent.trim() + blocked;
      if (target.closest('.product-item__size-dropdown select')) return 'card_size_dropdown' + blocked;
      if (target.closest('.product-item__cta-wrapper button[type="submit"]')) return 'card_choose' + blocked;
      if (target.closest('[is="toggle-button"]')) return 'card_size_guide';
      if (target.closest('.product-item__image-wrapper')) return 'card_image';
      if (target.closest('.product-item-meta__title')) return 'card_title';
      if (target.closest('.price-list')) return 'card_price';
      return 'card_other';
    }

    if (target.closest('.advent__powerstep')) {
      if (target.closest('.advent__powerstep__tile-btn')) return 'powerstep_gift_tile';
      if (target.closest('.advent__powerstep__gift-variants')) return 'powerstep_gift_size';
      if (target.closest('#OrderNowButton')) return 'powerstep_order_now';
      if (target.closest('.ResetCartButton')) return 'powerstep_reset';
      if (target.closest('.advent__powerstep__included')) return 'powerstep_included_info';
      if (target.closest('.advent__powerstep__intro')) return 'powerstep_intro_text';
      return 'powerstep_other';
    }

    if (target.closest('.advent__wrapper')) return 'wrapper_other';
    return null;
  }

  // Capture phase, so the tap is logged even if another handler stops propagation
  document.addEventListener('click', function(event) {
    var zone = zoneFor(event.target);
    if (!zone) return;
    clarityCall('event', 'advent_tap_' + zone);

    // Which product, for image/name taps (accumulates as a session tag)
    if (zone === 'card_image' || zone === 'card_title') {
      var title = event.target.closest('.product-item').querySelector('.product-item-meta__title');
      if (title) clarityCall('set', 'advent_tapped_product', title.textContent.trim());
    }
  }, true);
})();
